import flow from "lodash/flow";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { DragSource, DropTarget } from "react-dnd";
import { getEmptyImage } from "react-dnd-html5-backend";
import { findDOMNode } from "react-dom";

const listItemSource = {
  beginDrag(props) {
    return {
      index: props.sortIndex,
      originalIndex: props.originalIndex,
      listId: props.listId,
      item: props.item,
      source: props.source,
      preventDropOn: props.preventDropOn,
      className: props.className,
      listClassName: props.listClassName
    };
  },
  endDrag(props, monitor) {
    const item = monitor.getItem(),
      dropResult = monitor.getDropResult();

    if (!monitor.didDrop()) {
      props.moveListItem(item.index, item.originalIndex);
      document
        .querySelectorAll("li.over")
        .forEach(over => over.classList.remove("over"));
      return;
    }

    if (dropResult && dropResult.listId !== item.listId) {
      props.removeItem(item.index);
    }
  }
};

const listItemTarget = {
  canDrop(props, monitor) {
    const item = monitor.getItem(),
      preventDropOn = item.preventDropOn;
    if (!preventDropOn) return true;
    else return preventDropOn !== props.listId;
  },
  hover(props, monitor, component) {
    const item = monitor.getItem(),
      dragIndex = item.index,
      hoverIndex = props.sortIndex,
      sourceListId = item.listId;

    if (dragIndex === hoverIndex) return;

    const hoverBoundingRect = findDOMNode(component).getBoundingClientRect(),
      hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2,
      clientOffset = monitor.getClientOffset(),
      hoverClientY = clientOffset.y - hoverBoundingRect.top;

    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) return;
    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) return;

    findDOMNode(component)
      .parentNode.querySelectorAll(".over")
      .forEach(over => {
        over.classList.remove("over");
      });
    findDOMNode(component).classList.add("over");

    if (props.listId === sourceListId) {
      props.moveListItem(dragIndex, hoverIndex);
      item.index = hoverIndex;
    }
  }
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
  };
}

const itemClassName = (hidden, isDragging, className) => {
  let classList = [];
  if (typeof className === "string") {
    classList = className.split(" ");
  }
  if (hidden) {
    classList.push("hidden");
  } else if (isDragging) {
    classList.push("dragging");
  }
  return classList.join(" ");
};

class SortListItem extends Component {
  componentDidMount() {
    // Use empty image as a drag preview so browsers don't draw it
    // and we can draw whatever we want on the custom drag layer instead.
    this.props.connectDragPreview(getEmptyImage(), {
      // IE fallback: specify that we'd rather screenshot the node
      // when it already knows it's being dragged so we can hide it with CSS.
      captureDraggingState: true
    });
  }
  render() {
    const {
      connectDragSource,
      connectDropTarget,
      isDragging,
      children,
      preventDrag,
      hidden,
      className
    } = this.props;
    if (preventDrag) {
      return connectDropTarget(
        <li
          ref={li => (this.element = li)}
          className={itemClassName(hidden, isDragging, className)}
        >
          {children}
        </li>
      );
    }
    return connectDragSource(
      connectDropTarget(
        <li
          ref={li => (this.element = li)}
          className={itemClassName(hidden, isDragging, className)}
        >
          {children}
        </li>
      )
    );
  }
}

SortListItem.propTypes = {
  id: PropTypes.any,
  moveListItem: PropTypes.func
};

export default flow(
  DropTarget("SortListItem", listItemTarget, connect => ({
    connectDropTarget: connect.dropTarget()
  })),
  DragSource("SortListItem", listItemSource, collect)
)(SortListItem);
